// extracted by mini-css-extract-plugin
export default {"main_css_us":"SecondaryInputCheckbox_main_css_us__N-tOB","main_css_jp":"SecondaryInputCheckbox_main_css_jp__B+s6E","text":"SecondaryInputCheckbox_text__l+ZP4"};